<div mat-dialog-title style="font-size: 14px">
  <!-- Search field -->
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-icon matIconPrefix>search</mat-icon>
    <mat-label id="search-label" for="qa-search-facilities">{{ 'Search Facilities by Name' | translate: locale.language }}</mat-label>
    <input matInput type="text" id="qa-search-facilities" [formControl]="searchControl" />
  </mat-form-field>
</div>
<div mat-dialog-content>
  <!-- Loading Spinner -->
  @if (!lastResponse) {
    <div class="row loading-centered">
      <app-loading
        [hasLoaded]="!!lastResponse"
        [hasFailed]="loadError"
        (retryClicked)="fetchFacilities(1)"></app-loading>
    </div>
  }

  <!-- Facility list -->
  @if (lastResponse) {
    <div>
      <div class="collection qa-facility-collection" id="facilitiesList">
        @for (facility of lastResponse.items; track facility.id) {
          <a
            id="facilityName"
            class="qa-facility-select collection-item as-blue-highlight"
            (click)="onSelectedChange(facility)"
            [class.active]="isSelected(facility)"
            (keydown.enter)="onSelectedChange(facility)"
            (keydown.space)="$event.preventDefault(); onSelectedChange(facility)"
            tabindex="0">
            {{ facility.name }}
          </a>
        }
      </div>
      @if (lastResponse.totalItemCount > lastResponse.pageSize) {
        <mat-paginator
          id="facilities"
          [length]="lastResponse.totalItemCount"
          [pageSize]="lastResponse.pageSize"
          [pageIndex]="lastResponse.page - 1"
          [hidePageSize]="true"
          (page)="onPageChange($event.pageIndex + 1)">
        </mat-paginator>
      }
    </div>
  }
</div>
<div mat-dialog-actions class="right">
  <button mat-button id="cancel" color="primary" (click)="onCancelClick()">
    {{ 'Cancel' | translate: locale.language }}
  </button>
  <button mat-raised-button color="primary" id="okBtn" (click)="onDoneSelecting()">
    {{ 'OK' | translate: locale.language }}
  </button>
</div>
